module.exports = __webpack_public_path__ + "img/puzzle_27.e4dc0731.png";